import React from "react";
import {
  GraduationCap, HeartPulse, Utensils, Droplets, Users, Baby, Leaf, Wifi, HandHeart,
} from "lucide-react";

const MAP = {
  "graduation-cap": GraduationCap,
  "heart-pulse": HeartPulse,
  utensils: Utensils,
  droplets: Droplets,
  users: Users,
  baby: Baby,
  leaf: Leaf,
  wifi: Wifi,
};

export default function ProgramIcon({ name, className = "h-6 w-6" }) {
  const Icon = MAP[name] || HandHeart;
  return <Icon className={className} />;
}
